import React, { FC } from "react";
import { useTheme } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import {
  ContentBox,
  ImageBox,
  StyledCloseButton,
  StyledContainer,
  StyledContent,
  StyledImage,
} from "./WelcomeBanner.styled";

import { CustomColors } from "@type/CustomPalette";
import { Typography } from "@components/base";

export interface WelcomeBannerProps {
  color: CustomColors;
  title: string;
  text: string;
  icon: "accountant" | "data-cloud" | "globe";
  onClose?: () => void;
}

const WelcomeBanner: FC<WelcomeBannerProps> = ({
  color,
  title,
  text,
  icon,
  onClose,
}) => {
  const theme = useTheme();

  return (
    <StyledContainer backgroundColor={theme.palette.custom[color][50]}>
      <StyledCloseButton
        onClick={onClose}
        sx={{
          background: "#FFFFFF80",
          ":hover": {
            backgroundColor: theme.palette.custom[color][100],
          },
        }}
        size="small"
      >
        <CloseIcon fontSize="small" />
      </StyledCloseButton>
      <StyledContent>
        <ContentBox>
          <Typography variant="subtitle1">{title}</Typography>
          <Typography variant="body2">{text}</Typography>
        </ContentBox>
        <ImageBox>
          <StyledImage src={`/static/cards/${icon}-${color}.svg`} alt="" />
        </ImageBox>
      </StyledContent>
    </StyledContainer>
  );
};

export default WelcomeBanner;
